import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { v4 as uuid } from "uuid";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import { t } from "../../Helper";
import { useSelector } from "react-redux";
import { uploadMediaData, deleteData } from "../../services/apiService";

const ProductsInfo = ({ onChange, savedProducts }) => {
  const [productName, setProductName] = useState("");
  const [productDesc, setProductDesc] = useState("");
  const [productImage, setProductImage] = useState("");
  const [productFileName, setProductFileName] = useState("");

  const [addProduct, setAddProduct] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const [productDetail, setProductDetail] = useState("");
  const [products, setProducts] = useState(savedProducts);

  const [productList, setProductList] = useState("Your Product List");
  const [image, setImage] = useState("Image");
  const [productNameLabel, setProductNameLabel] = useState("Product Name");
  const [actions, setActions] = useState("Actions");
  const [addProductLabel, setAddProductLabel] = useState("Add Product");
  const [addMoreProduct, setAddMoreProduct] = useState("Add More Product");
  const [addNewProduct, setAddNewProduct] = useState("Add New Product");
  const [productDescription, setProductDescription] = useState(
    "Product Description"
  );
  const [uploadProductImage, setUploadProductImage] = useState(
    "Upload Product Image"
  );
  const [optional, setOptional] = useState("Optional");
  const [productDetails, setProductDetails] = useState("Product Details");

  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          productList,
          currentLanguage,
          preferredLanguage
        );
        setProductList(fetchedData);

        const fetchedData2 = await t(image, currentLanguage, preferredLanguage);
        setImage(fetchedData2);

        const fetchedData3 = await t(
          productNameLabel,
          currentLanguage,
          preferredLanguage
        );
        setProductNameLabel(fetchedData3);

        const fetchedData4 = await t(
          actions,
          currentLanguage,
          preferredLanguage
        );
        setActions(fetchedData4);

        const addProductData = await t(
          addProductLabel,
          currentLanguage,
          preferredLanguage
        );
        setAddProductLabel(addProductData);

        const addMoreProductData = await t(
          addMoreProduct,
          currentLanguage,
          preferredLanguage
        );
        setAddMoreProduct(addMoreProductData);

        const addNewProductData = await t(
          addNewProduct,
          currentLanguage,
          preferredLanguage
        );
        setAddNewProduct(addNewProductData);

        const productDescriptionData = await t(
          productDescription,
          currentLanguage,
          preferredLanguage
        );
        setProductDescription(productDescriptionData);

        const uploadProductImageData = await t(
          uploadProductImage,
          currentLanguage,
          preferredLanguage
        );
        setUploadProductImage(uploadProductImageData);

        const productDetailsData = await t(
          productDetails,
          currentLanguage,
          preferredLanguage
        );
        setProductDetails(productDetailsData);

        const optionalData = await t(
          optional,
          currentLanguage,
          preferredLanguage
        );
        setOptional(optionalData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file != "" || file != null) {
      let isError = mediaValidationCheck(file);
      if (isError) {
        return false;
      }

      const formData = new FormData();
      formData.append("file", file);
      // make a POST request to the File Upload API with the FormData object and Rapid API headers

      try {
        const res = await uploadMediaData(
          "public/api/v1/uploadMedia",
          formData
        );
        if (res.result) {
          let mediaDetails = res.data;
          setProductImage(mediaDetails.imageUrl);
          setProductFileName(mediaDetails.fileName);
          toast.success("Product image has been uploaded, successfully.");
        } else if (!res.success) {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to load data", error);
      }
    }
  };

  const mediaValidationCheck = (file) => {
    let isError = false;
    const fileSize = file.size / 1000;
    const allowedFileSize = ["1 MB"];
    if (fileSize > 1000) {
      toast.error(`File size must be ${allowedFileSize.join(", ")}`);
      isError = true;
    }

    const fileExtension = file.name.split(".").at(-1);
    const allowedFileTypes = ["png", "jpeg", "jpg", "gif"];
    if (!allowedFileTypes.includes(fileExtension)) {
      toast.error(
        `File does not support. Files type must be ${allowedFileTypes.join(
          ", "
        )}`
      );
      isError = true;
    }
    return isError;
  };

  const showProductDetail = (detail) => {
    setProductDetail(detail);
    setShowDetail(true);
  };

  /**
   * Save/Add New Product
   */

  const saveProduct = () => {
    /* Validations */
    if (productName === "" || productDesc === "") {
      toast.error("Please specify name and description !");
      return false;
    }

    let productList = products;

    productList.push({
      productId: uuid(),
      name: productName,
      desc: productDesc,
      image: productImage,
      imageFileName: productFileName,
    });

    setProducts(productList);

    setProductName("");
    setProductDesc("");
    setProductImage("");
    setAddProduct(false);

    toast.success("Saved, successfully.");
  };

  const deleteRecord = async (pId, itemImage) => {
    let productList = products;
    productList = productList.filter((record) => record.productId !== pId);
    setProducts(productList);

    /* DELETE PRODUCT IMAGE */

    try {
      let mediaFileInfo = itemImage.split(".com/");
      const res = await deleteData(
        "public/api/v1/deleteMedia?file=" + mediaFileInfo[1]
      );
      toast.success("Deleted, Successfully.");
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  /* Uploading Product Images */

  const handleProductClose = () => {
    setAddProduct(false);
    setShowDetail(false);
    setProductDetail("");
  };

  useEffect(() => {
    onChange(products);
  }, [products]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="form-label section-title">{productList}</label>
        <div>
          <button
            id="addProductBtn"
            type="button"
            className="btn btn-sm btn-primary"
            onClick={(e) => setAddProduct(true)}
          >
            <i className="bi bi-plus"></i>{" "}
            {products.length > 0 ? addMoreProduct : addProductLabel}
          </button>
        </div>
      </div>

      <div id="productsArea" className="list-group mb-3">
        {products.map((item, index) => (
          <div className="list-group-item d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              {item.image === "" ? (
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                  className="product-thumb"
                ></img>
              ) : (
                <img
                  src={item.image}
                  alt={item.name}
                  className="product-thumb"
                />
              )}
              <div>
                <div className="fw-bold">{item.name}</div>
              </div>
            </div>
            <div>
              <button
                className="btn btn-sm btn-outline-secondary me-2"
                onClick={(e) => showProductDetail(item.desc)}
              >
                <i className="bi bi-eye"></i>
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={(e) =>
                  deleteRecord(item.productId, item.imageFileName)
                }
              >
                <i className="bi bi-trash"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      <Modal show={showDetail} onHide={handleProductClose} size="lg">
        <Modal.Header>
          <Modal.Title>{productDetails}</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleProductClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>{productDetail}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleProductClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={addProduct}
        onHide={handleProductClose}
        size="lg"
        className="modal fade"
        id="itemModal"
        tabindex="-1"
        aria-hidden="true"
      >
        <Modal.Header>
          <Modal.Title>{addNewProduct}</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleProductClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card p-5">
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12 p-2">
                  <input
                    type="text"
                    className="form-control"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    required
                    placeholder={productNameLabel}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12 p-2">
                  <textarea
                    rows="5"
                    cols="33"
                    className="form-control"
                    value={productDesc}
                    onChange={(e) => setProductDesc(e.target.value)}
                    required
                    placeholder={productDescription}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-4 p-2">
                  {uploadProductImage} ({optional})
                </div>
                <div className="input-group col-sm-4 p-2">
                  <input
                    type="file"
                    label="Image"
                    name="myFile"
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) => handleFileUpload(e)}
                  />
                </div>
                <div className="input-group col-sm-4 p-2">
                  {productImage === "" ? (
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    ></img>
                  ) : (
                    <img
                      src={productImage}
                      alt={productName}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleProductClose}>
            Close
          </Button>
          <Button variant="primary" onClick={saveProduct}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductsInfo;
